import { render } from "./AgenteActas.vue?vue&type=template&id=2d882642&scoped=true"
import script from "./AgenteActas.vue?vue&type=script&lang=ts"
export * from "./AgenteActas.vue?vue&type=script&lang=ts"

import "./AgenteActas.vue?vue&type=style&index=0&id=2d882642&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d882642"

export default script